import { useEffect, useState } from 'react'
import api, { IBookingImportFailed } from '@api'
import { IGridTableCell, GridTableStatusEnum } from '@ui'

export interface IBookingImportFailedWithId extends IBookingImportFailed {
  id: string
}

export default function useImportFailed(id: string): {
  failedImportBookings: IGridTableCell<IBookingImportFailedWithId>[]
  status: GridTableStatusEnum
} {
  const [failedImportBookings, setImportFailed] = useState<
    IGridTableCell<IBookingImportFailedWithId>[]
  >([])
  const [status, setStatus] = useState<GridTableStatusEnum>(GridTableStatusEnum.LOADING)

  useEffect(() => {
    api.booking.import.failed(id).then(({ failed }) => {
      if (failed) {
        const newFailed = failed.map((f) => ({ data: { ...f, id: '' } }))
        setImportFailed(newFailed)
      }
      setStatus(GridTableStatusEnum.IDLE)
    })
  }, [id])

  return {
    failedImportBookings,
    status,
  }
}
